export default __webpack_public_path__ + "static/media/Rectangle7.8ea9a88e.png";